._preview_9jshw_1 {
  margin-bottom: 0;
  width: 100%; }
